/**
 * Articles Page
 * Displays list of all articles
 */

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import apiClient from '../api/client';
import Navbar from '../components/Navbar';

const ArticlesPage = () => {
  const navigate = useNavigate();
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchArticles();
  }, []);

  const fetchArticles = async () => {
    try {
      const response = await apiClient.get('/articles');
      if (response.data.success) {
        setArticles(response.data.articles);
      }
    } catch (err) {
      setError('Failed to load articles');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric' 
    });
  };

  if (loading) {
    return <div style={{ padding: '50px', textAlign: 'center' }}>Loading articles...</div>;
  }

  if (error) {
    return (
      <div style={{ padding: '50px', textAlign: 'center' }}>
        <p style={{ color: 'red' }}>{error}</p>
        <button onClick={() => navigate('/')}>Go Home</button>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: '1000px', margin: '50px auto', padding: '20px', paddingTop: '140px' }}>
<Navbar />
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px' }}>
        <h1>All Articles</h1>
        <button 
          onClick={() => navigate('/')}
          style={{ 
            padding: '10px 20px', 
            backgroundColor: '#6c757d',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          Back to Home
        </button>
      </div>

      {articles.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '50px' }}>
          <p>No articles yet. Be the first to post one!</p>
        </div>
      ) : (
        <div style={{ display: 'grid', gap: '20px' }}>
          {articles.map((article) => (
            <div 
              key={article.id}
              onClick={() => navigate(`/articles/${article.id}`)}
              style={{ 
                border: '1px solid #ddd',
                borderRadius: '8px',
                padding: '20px',
                cursor: 'pointer',
                backgroundColor: '#fff',
                transition: 'box-shadow 0.2s'
              }}
              onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.1)'}
              onMouseLeave={(e) => e.currentTarget.style.boxShadow = 'none'}
            >
              <h2 style={{ marginTop: 0, marginBottom: '10px' }}>{article.description}</h2>
              
              {article.article_type && article.article_type.length > 0 && (
                <div style={{ marginBottom: '10px' }}>
                  {article.article_type.map((type, index) => (
                    <span 
                      key={index}
                      style={{ 
                        display: 'inline-block',
                        backgroundColor: '#007bff',
                        color: 'white',
                        padding: '4px 8px',
                        borderRadius: '4px',
                        fontSize: '12px',
                        marginRight: '5px'
                      }}
                    >
                      {type.replace('_', ' ')}
                    </span>
                  ))}
                </div>
              )}

              {(article.city || article.state) && (
                <p style={{ margin: '5px 0', color: '#666' }}>
                  <strong>📍 Location:</strong> {article.city}{article.city && article.state ? ', ' : ''}{article.state}
                </p>
              )}
              
              <p style={{ margin: '5px 0', color: '#666', fontSize: '14px' }}>
                <strong>Posted:</strong> {formatDate(article.created_at)}
              </p>

              <p style={{ 
                margin: '10px 0 0 0', 
                color: '#444',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: '-webkit-box',
                WebkitLineClamp: 3,
                WebkitBoxOrient: 'vertical'
              }}>
                {article.body}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ArticlesPage;
